import propEq from "ramda/es/propEq";
import reject from "ramda/es/reject";
export default {
    next (state, action) {
        return {
            ...state,
            toasts: reject(propEq(action.payload.id, 'id'), state.toasts)
        };
    }
};
